import React from 'react';
import { Form, Row, Col, Button } from "antd";
import {
    fieldGenerator,
    getErrorOnField,
    getValidateStatus
} from "utilities/form";
import PropTypes from "prop-types";
import  { ONBOARDING_CONTROLS_FIELDS }  from "constants/form-fields";
import { MpaFormsFooter } from '../../modules/companies/modules/mpa-form-footer';


class OnboardingControlForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    getValidateStatus = getValidateStatus.bind(this.props.form);

    onSave = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if(!err){
                this.props.updateDetail(this.props.form.getFieldsValue())
            }
        }); 
    }

    onApprove = () => {
        this.props.form.validateFields((err, values) => {
            if(!err){
                this.props.approveDetails()
            }
        }); 
    }

    handleFieldValueChange = (fieldName, value) => {
        if(fieldName == "retailer_risk_security_type" && value == 5){
            this.props.form.setFieldsValue({
                retailer_risk_holdback_perc: null,
                retailer_risk_security_amount: null,
                retailer_holdback_calculation_type: null
            })
        }

        if (fieldName == "retailer_holdback_calculation_type") {
            this.props.form.setFieldsValue({
                retailer_risk_holdback_perc: null,
                retailer_risk_security_amount: null,
            })
        }
    }
    render() {
        return (
            <div className={"d-flex flex-row justify-content-space-between flex-wrap w-100 form"}>
                <Row>
                <Form onSubmit={this.onSave}>

                <Row>
                        {ONBOARDING_CONTROLS_FIELDS.map((field, fieldName) => {
                            if(fieldName == 'mandatory_documents_for_buyer' || fieldName == 'non_mandatory_documents_for_seller' || fieldName == 'non_mandatory_documents_for_buyer'){
                                field.options = this.props.docMasterList.map((_,key) => {
                                  return {
                                    document_name: _.document_name,
                                    id: _.id                    
                                }})
                            }
                            field.disabled = this.props.disableFields;
                            if(!this.props.disableFields){
                                if (fieldName == "retailer_risk_holdback_perc") {
                                    const retailer_holdback_calculation_type = this.props.form.getFieldValue("retailer_holdback_calculation_type");
                                    const retailer_risk_security_type = this.props.form.getFieldValue("retailer_risk_security_type");
                                    if (retailer_holdback_calculation_type == 2) {
                                        field.disabled = false;
                                        field.rules = [
                                            {
                                                required: true,
                                                message: "Field is Required"
                                            },
                                            {
                                                pattern: /^(100(\.0{1,2})?|\d{1,2}(\.\d{1,2})?|0(\.\d{1,2})?)$/,
                                                message: "Input must be between 0 and 100"
                                            }
                                        ];
                                    } else {
                                        field.disabled = true;
                                        field.rules = [{
                                            required: false
                                        }];
                                    }
                                    if (retailer_risk_security_type == 5) {
                                        field.disabled = true;
                                        field.rules = [{
                                            required: false
                                        }];
                                    }
                                }
                                if (fieldName == "retailer_risk_security_amount") {
                                    const retailer_holdback_calculation_type = this.props.form.getFieldValue("retailer_holdback_calculation_type");
                                    const retailer_risk_security_type = this.props.form.getFieldValue("retailer_risk_security_type");
                    
                                    if (retailer_holdback_calculation_type == 2) {
                                        field.disabled = true;
                                        field.rules = [{
                                            required: false
                                        }];
                                    } else {
                                        field.disabled = false;
                                        field.rules = [
                                            {
                                                required: true,
                                                message: "Field is Required"
                                            },{
                                                pattern: /^(?:\d*\.)?\d+$/,
                                                message: "Please enter a valid number"
                                            }
                                        ];
                                    }
                                    if (retailer_risk_security_type == 5) {
                                        field.disabled = true;
                                        field.rules = [{
                                            required: false
                                        }];
                                    }
                                }
                                if (fieldName == "retailer_holdback_calculation_type") {
                                    const security_type = this.props.form.getFieldValue("retailer_risk_security_type");
                                    if (security_type == 5) {
                                        field.disabled = true;
                                        field.rules = [{
                                            required: false
                                        }];
                                    }else{
                                        field.disabled = false;
                                        field.rules = [
                                            {
                                                required: true,
                                                message: "Field is Required"
                                            }
                                        ];
                                    }
                                }
                            }
                           
                            
                            const value = this.props.values && this.props.values[fieldName];
                            return <Col span="8">{this.fieldGenerator(
                                fieldName,
                                { ...field, value },
                                this.getValidateStatus(fieldName),
                                (e) => this.handleFieldValueChange(fieldName, (field.type == "SELECT" ? e :  e.target.value)),
                                true
                            )()}</Col>
                        }).toList()}

                </Row>
                <Row>
                    <MpaFormsFooter
                        disableFields={this.props.disableFields}
                        approveDisabled={this.props.approveDisabled}
                        onApprove={this.onApprove}
                    />
                </Row>
                </Form>

                </Row>
            </div>
        );
    }
}

OnboardingControlForm.propTypes = {
    approveDetails: PropTypes.func,
    approveDisabled: PropTypes.bool,
    disableFields: PropTypes.bool
};

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return values &&
            values
                .map((value, key) => {
                    if(["retailer_risk_security_type"].includes(key) && [null, "", 0].includes(value)){
                        return Form.createFormField({
                            value: 1
                        });
                    }
                    return Form.createFormField({
                        value
                    });
                }).toJS();
    },
    onValuesChange: (props, changedValues, values) => {
    }
})(OnboardingControlForm);